export function getBrowserLanguage() {
  let res = 'en';
  try {
    res = navigator.language.split('-')[0];
  } catch (e) {
    console.error('Cannot get the browser language.');
  }

  return res;
}
